import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import Landing from './pages/Landing/Landing';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Dashboard from './pages/Dashboard/Dashboard';
import Profile from './pages/Profile/Profile';
import Stake from './pages/Stake/Stake';
import Wallet from './pages/Wallet/Wallet';
import Deposit from './pages/Deposit/Deposit';
import Withdraw from './pages/Withdraw/Withdraw';
import Team from './pages/Team/Team';
import Rank from './pages/Rank/Rank';
import Settings from './pages/Settings/Settings';
import Support from './pages/Support/Support';
import Transfer from './pages/Transfer/Transfer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="animated-bg"></div>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes - Dashboard */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="stake" element={<Stake />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="deposit" element={<Deposit />} />
            <Route path="withdraw" element={<Withdraw />} />
            <Route path="team" element={<Team />} />
            <Route path="rank" element={<Rank />} />
            <Route path="settings" element={<Settings />} />
            <Route path="support" element={<Support />} />
            <Route path="transfer" element={<Transfer />} />

          </Route>

          {/* Logout Route */}
          <Route path="/logout" element={<Navigate to="/login" replace />} />

          {/* Catch all - redirect to landing */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;